import { render, staticRenderFns } from "./GroupRecordItem.vue?vue&type=template&id=fac47e72&"
import script from "./GroupRecordItem.vue?vue&type=script&lang=js&"
export * from "./GroupRecordItem.vue?vue&type=script&lang=js&"
import style0 from "./GroupRecordItem.vue?vue&type=style&index=0&id=fac47e72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports